import { render } from "./WelcomeSidebar.vue?vue&type=template&id=228c18b8&scoped=true"
import script from "./WelcomeSidebar.vue?vue&type=script&lang=js"
export * from "./WelcomeSidebar.vue?vue&type=script&lang=js"

import "./WelcomeSidebar.vue?vue&type=style&index=0&id=228c18b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228c18b8"]])

export default __exports__